// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hffS","badges":"styles_badges__1o8dd"};